
      <h2>{{titleMessage}}</h2>

      <div class="mb-2 mt-2">{{detailMessage}}</div>
      <div class="mb-2">{{contactMessage}}</div>
      <div class="mb-2" *ngIf="caller.parent === 'REGISTER'">
      <p class="invest_text">You may call us at <br><b><a href = "tel:+918904291440">+91 890 429 1440</a> </b><br>or email us at <a href="mailto:support@snithik.com">support&#64;snithik.com</a> for further assistance.
      </div>
        <div class="mb-2 forgot">
          <a routerLink="/access/login">Back to Login</a>
        </div>
      <div class="mb-2" *ngIf="caller.parent === 'RESET'">Please click here to <a class="link" routerLink="/access/login">Login.</a>
      </div>

